import Header from "../components/dashboard/Header";
import CameraWall from "../components/CameraWall";

export default function Cameras() {
  return (
    <div className="min-h-screen bg-brand-page">
      <Header />
      <main className="max-w-[1600px] mx-auto px-6 lg:px-12 py-10">
        <div className="mb-8">
          <h1 className="font-serif text-4xl sm:text-5xl text-brand-ink tracking-tight" data-testid="cameras-title">Cameras</h1>
          <p className="text-sm text-brand-muted mt-2">
            Live snapshot wall per location, refreshing automatically. Tap the
            <span className="mx-1 inline-flex items-center align-middle">↗</span>
            on any camera to open the full live view in UniFi Protect.
          </p>
        </div>
        <CameraWall showLocationHeaders />
      </main>
    </div>
  );
}
